import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared-module/shared.module';
import { ProcessApplicationComponent } from './children/process-application/process-application.component';
import { ProcessOneWayVideoComponent } from './children/process-one-way-video/process-one-way-video.component';
import { ProcessInterviewComponent } from './children/process-interview/process-interview.component';
import { ProcessOfferComponent } from './children/process-offer/process-offer.component';
import { ProcessEffects } from './effects/process.effects';
import { processesReducer } from './reducers/process.reducers';
import { StoreModule } from '@ngrx/store';
import { ProcessService } from '../../lib/services/processService';
import { EffectsModule } from '@ngrx/effects';
import { ProcessQualifiedComponent } from './children/process-qualified/process-qualified.component';
import { ProcessHiredComponent } from './children/process-hired/process-hired.component';
import { ProcessDeclinedComponent } from './children/process-declined/process-declined.component';
import { ProcessWaitlistComponent } from './children/process-waitlist/process-waitlist.component';
import { ProcessStepComponent } from './children/process-step/process-step.component';
import { QuestionsModule } from '../../questions-module/questions.module';
import { EditJobTplJobProcessComponent } from './edit-job-tpl-job-process.component';

@NgModule({
  declarations: [
    ProcessApplicationComponent,
    ProcessOneWayVideoComponent,
    ProcessInterviewComponent,
    ProcessOfferComponent,
    ProcessQualifiedComponent,
    ProcessHiredComponent,
    ProcessDeclinedComponent,
    ProcessWaitlistComponent,
    ProcessStepComponent,
    EditJobTplJobProcessComponent,
  ],

  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatCheckboxModule,
    CommonModule,
    MatButtonModule,
    MatChipsModule,
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatOptionModule,
    MatSelectModule,
    QuestionsModule,
    StoreModule.forFeature('processes', processesReducer),
    EffectsModule.forFeature([ProcessEffects]),
  ],

  exports: [
    ProcessApplicationComponent,
    ProcessOneWayVideoComponent,
    ProcessInterviewComponent,
    ProcessOfferComponent,
    ProcessQualifiedComponent,
    ProcessHiredComponent,
    ProcessDeclinedComponent,
    ProcessWaitlistComponent,
    ProcessStepComponent,
    EditJobTplJobProcessComponent,
  ],

  providers: [ProcessService],
})
export class JobProcessModule {}
